import React from 'react';
import PropTypes from 'prop-types';
import Row from '../layout/Row';
import Column from '../layout/Column';
import LinearProgress from '../layout/LinearProgress';
import Separator from '../layout/Separator';
import Dialog from '../layout/Dialog';

const VideoUploadDialog = (props) => (
  <Dialog title="Video upload progress" isOpen={props.isOpen} closeable={false} actions={[]}>
    <Row>
      <Column size={12}>
        <LinearProgress
          value={props.values.uploadPercentage || 0}
          color={props.values.uploadPercentage && props.values.uploadPercentage >= 100 ? 'green' : 'blue'}
          showInfo
        />
        <Separator size="lg" />
      </Column>
    </Row>
  </Dialog>
);

VideoUploadDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  values: PropTypes.object,
};

VideoUploadDialog.defaultProps = {
  values: {},
};

export default VideoUploadDialog;
